(() => {
  const STORAGE_KEY = 'samduo_clarity_id';
  const STORAGE_EXPIRES_KEY = 'samduo_clarity_id_expires';
  const RETENTION_MS = 90 * 24 * 60 * 60 * 1000;
  const HASH_PATTERN = /^[a-f0-9]{64}$/;

  function normalizeEmail(value) {
    const email = String(value || '').trim().toLowerCase();
    return email.includes('@') ? email : '';
  }

  async function hashEmail(email) {
    if (!window.crypto?.subtle || typeof TextEncoder === 'undefined') return null;
    const bytes = new TextEncoder().encode(email);
    const digest = await window.crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
  }

  function readIdentifier() {
    try {
      const identifier = window.localStorage.getItem(STORAGE_KEY);
      if (!identifier) return null;

      const expiresAt = Number(window.localStorage.getItem(STORAGE_EXPIRES_KEY));
      if (expiresAt && expiresAt <= Date.now()) {
        window.localStorage.removeItem(STORAGE_KEY);
        window.localStorage.removeItem(STORAGE_EXPIRES_KEY);
        return null;
      }

      return identifier;
    } catch (error) {
      return null;
    }
  }

  function storeIdentifier(identifier) {
    try {
      window.localStorage.setItem(STORAGE_KEY, identifier);
      window.localStorage.setItem(STORAGE_EXPIRES_KEY, String(Date.now() + RETENTION_MS));
      return true;
    } catch (error) {
      return false;
    }
  }

  function whenClarityReady(callback) {
    if (typeof window.clarity === 'function') {
      callback();
      return;
    }

    const expiresAt = Date.now() + 10000;
    const tick = () => {
      if (typeof window.clarity === 'function') {
        callback();
        return;
      }
      if (Date.now() < expiresAt) window.setTimeout(tick, 300);
    };

    tick();
  }

  function identify(identifier) {
    whenClarityReady(() => window.clarity('identify', identifier));
  }

  function upgradeCheckoutIntent() {
    whenClarityReady(() => window.clarity('upgrade', 'checkout_intent'));
  }

  async function saveAndIdentifyEmail(value) {
    const email = normalizeEmail(value);
    if (!email) return;

    const identifier = await hashEmail(email);
    if (!identifier) return;

    storeIdentifier(identifier);
    identify(identifier);
  }

  async function migrateStoredIdentifier() {
    const storedIdentifier = readIdentifier();
    if (!storedIdentifier) return;

    if (HASH_PATTERN.test(storedIdentifier)) {
      storeIdentifier(storedIdentifier);
      identify(storedIdentifier);
      return;
    }

    const email = normalizeEmail(storedIdentifier);
    if (!email) return;

    const identifier = await hashEmail(email);
    if (!identifier) return;

    storeIdentifier(identifier);
    identify(identifier);
  }

  function findEmailInput(target) {
    if (!(target instanceof Element)) return null;
    if (target.matches('input[name="contact[email]"]')) return target;
    const form = target.closest('form');
    return form?.querySelector('input[name="contact[email]"]') || null;
  }

  function start() {
    migrateStoredIdentifier();

    document.addEventListener('submit', (event) => {
      const input = findEmailInput(event.target);
      if (input) saveAndIdentifyEmail(input.value);

      if (event.target instanceof HTMLFormElement && event.target.action.includes('/checkout')) {
        upgradeCheckoutIntent();
      }
    }, true);

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const checkoutLink = event.target.closest('a[href*="/checkout"], button[name="checkout"], [data-checkout]');
      if (checkoutLink) upgradeCheckoutIntent();
    }, true);
  }

  if (typeof ConsentAppLoader !== 'undefined') {
    ConsentAppLoader.whenConsented(start);
  }
})();
